// extracted by mini-css-extract-plugin
export default {"container":"Error_container__0AqZX","title":"Error_title__NQc9v","text":"Error_text__aHHte","link":"Error_link__BVT4l"};